import { useState } from 'react';
import { FormattedMessageDiv } from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { EmailCode } from './EmailCode';
import { VerifyCode } from './VerifyCode';

type OTPData = {
  key?: string;
  emailMasked?: string;
};

interface Props {
  OTPKey?: string;
  emailMasked?: string;
  headingMessageId?: string;
  onVerify?: any;
}

export const OTPassword = ({ OTPKey, emailMasked, headingMessageId = 'OTP.heading', onVerify }: Props) => {
  const [data, setData] = useState<OTPData>({ key: OTPKey, emailMasked: emailMasked });
  return (
    <Stack gap={2} className="align-items-center justify-content-center mt-3">
      <FormattedMessageDiv className="h3" id={headingMessageId} />
        {data.key
          ? <VerifyCode OTPKey={data.key} emailMasked={data.emailMasked} onVerify={onVerify} />
          : <EmailCode onNotify={setData} />
        }
    </Stack>
  );
};

export default OTPassword;
